var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getSizeValue, checkIsCSSLength, sizes } from "@bedrock-layout/spacing-constants";
import styled from "styled-components";
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
const Center = styled.div.attrs(({ centerChildren, centerText, maxWidth, theme, style }) => {
  var _a;
  const centerProps = [
    centerText && "center-text",
    centerChildren && "center-children"
  ].filter((x) => x).join(" ");
  return {
    "data-bedrock-center": centerProps,
    style: __spreadProps(__spreadValues({}, style), {
      "--maxWidth": typeof maxWidth === "number" && maxWidth > 0 ? `${maxWidth}px` : (_a = getSizeValue(theme, maxWidth)) != null ? _a : maxWidth
    })
  };
})`
  @property --maxWidth {
    syntax: "<length-percentage>";
    inherits: false;
    initial-value: 100%;
  }

  box-sizing: content-box;

  && {
    margin-inline-start: auto;
    margin-inline-end: auto;
    margin-inline: auto;
  }

  max-inline-size: var(--maxWidth, 100%);

  ${(props) => props.centerChildren && `display: flex;
    flex-direction: column;
    align-items: center;`}

  ${(props) => props.centerText && `text-align: center;`}
`;
Center.displayName = "Center";
function validateMaxWidth({ maxWidth }, propName) {
  if (maxWidth === void 0)
    return void 0;
  const isValid = typeof maxWidth === "number" || checkIsCSSLength(maxWidth) || Object.keys(sizes).includes(maxWidth);
  if (!isValid) {
    console.error(`${propName} needs to be an number, CSSLength or SizesOptions`);
  }
  return void 0;
}
Center.propTypes = {
  maxWidth: validateMaxWidth,
  centerText: PropTypes.bool,
  centerChildren: PropTypes.bool
};
export { Center };
